import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../../../helpers/custom-prop-types';
import ProfessionalMyPageTopProffitSearchSlideTagsContent from './ProffitSearchSlideTagsContent';
/**
 * Prpffit Searchの人気タグを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlideTags = (props) => {
    const { tags } = props;
    return (_jsxs("div", Object.assign({ className: 'professional_mypage_top_proffit_search_slide_tags' }, { children: [_jsx("div", Object.assign({ className: 'tags_title' }, { children: "\u30BF\u30B0\u3067\u63A2\u3059" })), _jsx(ProfessionalMyPageTopProffitSearchSlideTagsContent, { tags: tags })] })));
};
ProfessionalMyPageTopProffitSearchSlideTags.propTypes = {
    tags: propArrayShape(),
};
ProfessionalMyPageTopProffitSearchSlideTags.defaultProps = {
    tags: null,
};
export default ProfessionalMyPageTopProffitSearchSlideTags;
